import targetSize from '@features/campaigns/shared/assets/icons/target-size.png';

import styles from './TargetSizeIcon.module.scss';

export function TargetSizeIcon() {
  return <img className={styles.rightMargin} src={targetSize} alt='target size icon' />;
}
